import { Content } from '../models/content';

export const portugueseContent: Content = {
  translation: {
    title:
      'Operador de pool de staking Cardano sediado na Europa<br /> desenhado e construído por <a href="mailto:adapool_charles@pm.me">@Charles</a> e <a href="mailto:adapool_mikael@pm.me">@Mika</a>.',
    whoAreWe: 'Quem somos?',
    whyJoinUs: 'Porquê juntar-se a nós?',
    poolDetails: 'Detalhes do pool',
    s1: {
      p1: 'Somos o Charles 😊 e o Mika 😉, uma parceria de dois empresários franceses motivados para democratizar o uso de criptomoedas.',
      p2: 'Mika, que ajuda as administrações nas suas transformações digitais, traz a sua experiência técnica e humana. Charles traz mais de uma década de experiência em engenharia de software. Juntos, estamos a participar entusiasticamente no desenvolvimento da rede Cardano!',
      p3: 'Estamos envolvidos em criptomoedas desde 2017, quando tivemos a oportunidade de obter lucro no topo do mercado. Descobrimos o projeto Cardano nesse momento e, desde então, temos acompanhado com grande interesse. O nosso objetivo com o ADA Pool Europe é criar uma comunidade de pessoas que partilhem os nossos valores, acreditem no Cardano e à qual gostaríamos de oferecer uma boa experiência de pooling de capital.',
      p4: 'O nosso objetivo com o ADA Pool Europe é criar uma comunidade de pessoas que partilhem os nossos valores, acreditem no Cardano e à qual oferecemos uma boa experiência de pooling de capital.',
    },
    s2: {
      p1: 'Estamos motivados para democratizar o uso de criptomoedas.',
      p2: ' infraestrutura de alta disponibilidade',
      p3: ' com taxas limitadas',
      p4: ' aberto ao maior público possível',
      p5: ' servidores dedicados e seguros',
      p6: 'O nosso pool de staking Cardano sediado na Europa dedica-se a fortalecer e decentralizar a rede Cardano. \n Oferecemos staking de alta disponibilidade, fiável e seguro, baseado em dois nós de retransmissão e um nó produtor em centros de servidores de classe empresarial. O nosso objetivo é criar uma boa experiência para o participante.',
      p7: 'Damos um forte enfoque ao desempenho e segurança da nossa infraestrutura de pool. Gostaríamos de permitir que o maior número possível de pessoas participasse na aventura cripto.',
      p8: 'Ao fazer staking dos seus ADAs no nosso pool, participa na operação da rede Cardano.',
      p9: "✔&nbsp;Os seus ADAs nunca são bloqueados, pode transferi-los a qualquer momento e sem penalização&nbsp;;<br><br> ✔&nbsp;Os seus ADAs estão sempre na sua carteira, ficam consigo. Não os pode perder pelo método de 'staking' &nbsp;;<br><br> ✔&nbsp;As suas recompensas são reinvestidas automaticamente. A cada 5 dias recebe a sua parte dos ganhos que são automaticamente acumulados&nbsp;;<br><br> ✔&nbsp;Pode começar a acumular o seu ADA, mesmo que tenha muito pouco.",
    },
    s3: {
      p1: 'Participar na rede Cardano é fácil!<br>Basta fazer staking das suas criptomoedas ADA no nosso pool "adapool-europe".',
      p2: 'O identificador a introduzir para delegar o seu ADA:',
      p3: 'Widget interativo',
      p4: 'Pledge',
      p5: 'Proprietários:',
      p6: 'Valor:',
      p7: ' Stake',
      p8: 'Delegados:',
      p9: 'Valor:',
      p10: 'Taxas',
      p11: 'Taxas variáveis:',
      p12: 'Taxa fixa:',
      p13: 'Preço da criptomoeda',
    },
    footer: {
      p1: 'Contacte-nos',
    },
  },
};
